import { of } from 'rxjs';
import { CurrentRoute } from './current-route.model';

export const currentRoute: CurrentRoute<Record<string, undefined>> = {
    queryParams: {},
    queryParamsChanged: of({}),
    goTo: () => undefined,
};
